import axios from 'axios'

import Global from "@/config/global.config"

const service = axios.create({
  baseURL: Global.domainUrl,
  timeout: Global.http.timeout,
})

service.postAction = function (url,params,authorize = false) {
  let config = {
    url: url,
    method:'post',
    data: params ,
    headers:{}
  }
  return this(config)
}

service.putAction = function (url,params,authorize = false) {
  let config = {
    url: url,
    method:'put' ,
    data: params ,
    headers:{}
  }
  return this(config)
}

service.deleteAction = function (url,params,authorize = false) {
  let config = {
    url: url,
    method:'delete',
    params: params ,
    headers:{}
  }
  return this(config)
}

service.getAction = function (url,params,authorize = false) {
  let config = {
    url: url,
    method:'get' ,
    params: params ,
    headers:{}
  }
  return this(config)
}

service.downFile = function (url,parameter,authorize = false){
  let config = {
    url: url,
    params: parameter,
    method:'get' ,
    responseType: 'blob' ,
    headers:{}
  }
  return this(config)
}

const err = function (error) {
  if (error.response) {
    let data = error.response.data
    console.log("------异常响应------",error.response.status, data)
  }
  return Promise.reject(error)
}

service.interceptors.request.use(config => {

  if (config.method === 'get') {
    config.params = {
      _t: Date.parse(new Date()) / 1000,
      ...config.params
    }
  }
  config.headers['Zwsk-TenantId'] = process.env.VUE_APP_TENANT_ID || "000000"
  return config
}, (error) => {
  return Promise.reject(error)
})

service.interceptors.response.use((response) => {
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    if (this.installed) {
      return
    }
    this.installed = true

    if (!service) {
      console.error('You have to install axios')
      return
    }

    // Vue.axios = instance
    Object.defineProperties(Vue.prototype, {
      axios: {
        get: function get () {
          return service
        }
      },
      $http: {
        get: function get () {
          return service
        }
      }
    })
    // Vue.use(VueAxios, router, service)
  }
}


export {
  installer as VueAxios,
  service as axios
}


